import { render, staticRenderFns } from "./modalCadastro.vue?vue&type=template&id=d07ead8a&scoped=true&"
import script from "./modalCadastro.vue?vue&type=script&lang=js&"
export * from "./modalCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07ead8a",
  null
  
)

export default component.exports